import { render } from "./verifyPage.vue?vue&type=template&id=06e2b20c&scoped=true"
import script from "./verifyPage.vue?vue&type=script&lang=js"
export * from "./verifyPage.vue?vue&type=script&lang=js"

import "./verifyPage.vue?vue&type=style&index=0&id=06e2b20c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e2b20c"]])

export default __exports__